import { Component, Inject, Injector, OnInit } from '@angular/core';
import { RootMixin, UserAwareMixin } from '@fapp/mixins';
import { TuiDialogService } from '@taiga-ui/core';
import { PolymorpheusComponent } from '@taiga-ui/polymorpheus';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-quick-add-menu',
  templateUrl: './quick-add-menu.component.html',
  styleUrls: ['./quick-add-menu.component.scss'],
  standalone: false,
})
export class QuickAddMenuComponent
  extends UserAwareMixin(RootMixin)
  implements OnInit
{
  luser: Observable<any>;

  constructor(
    @Inject(TuiDialogService) private readonly dialogs: TuiDialogService,
    @Inject(Injector) private readonly injector: Injector
  ) {
    super();
  }

  ngOnInit(): void {
    this.luser = this.currentUser.valueChanges.pipe(
      map((res: any) => res.data.currentUser)
    );
  }

  qaUser(): void {
    import('../../../views/shared/users/user-edit/user-edit.component').then(
      ({ UserEditComponent }) => {
        // noinspection TypeScriptValidateTypes
        this.dialogs
          .open<any>(
            new PolymorpheusComponent(UserEditComponent, this.injector),
            {
              dismissible: false,
              closeable: false,
              size: 'auto',
              appearance: 'quick-add',
            }
          )
          .subscribe();
      }
    );
  }

  qaCompany(): void {
    import(
      '../../../views/shared/companies/company-edit/company-edit.component'
    ).then(({ CompanyEditComponent }) => {
      // noinspection TypeScriptValidateTypes
      this.dialogs
        .open<any>(
          new PolymorpheusComponent(CompanyEditComponent, this.injector),
          {
            dismissible: false,
            closeable: false,
            size: 'auto',
            appearance: 'quick-add',
          }
        )
        .subscribe();
    });
  }
}
